var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// /home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-tel-input/node_modules/core-js/internals/path.js
// module id = 190
// module chunks = 0